import { STAFF_MEMBER_REQUESTS_ENTITY } from '../../../constants/entity'
import {
  USER_PROFILE_TAB_ATTRIBUTES,
  USER_PROFILE_TAB_BUILDINGS,
  USER_PROFILE_TAB_CATEGORIES,
  USER_PROFILE_TAB_CONTRACTS,
  USER_PROFILE_TAB_DOCUMENTS,
  USER_PROFILE_TAB_EMAILS,
  USER_PROFILE_TAB_POSTS,
  USER_PROFILE_TAB_REQUESTS,
  USER_PROFILE_TAB_REQUESTS_STAFF_MEMBER_FILTER_KEY,
  USER_PROFILE_TAB_UPDATES,
} from '../../UserProfileTab'

export const INHABITANT_PROFILE_TAB_LIST = [
  USER_PROFILE_TAB_CONTRACTS,
  USER_PROFILE_TAB_REQUESTS,
  USER_PROFILE_TAB_EMAILS,
  USER_PROFILE_TAB_DOCUMENTS,
  USER_PROFILE_TAB_ATTRIBUTES,
  USER_PROFILE_TAB_POSTS,
  USER_PROFILE_TAB_UPDATES,
]

export const STAFF_PROFILE_TAB_LIST = [
  {
    ...USER_PROFILE_TAB_REQUESTS,
    contentProps: {
      entity: STAFF_MEMBER_REQUESTS_ENTITY,
      scopeFilterKey: USER_PROFILE_TAB_REQUESTS_STAFF_MEMBER_FILTER_KEY,
    },
  },
  USER_PROFILE_TAB_EMAILS,
  USER_PROFILE_TAB_BUILDINGS,
  USER_PROFILE_TAB_CATEGORIES,
  USER_PROFILE_TAB_DOCUMENTS,
  USER_PROFILE_TAB_POSTS,
  USER_PROFILE_TAB_UPDATES,
]
